import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import sanityClient from "../Client";
import * as FIIcons from "react-icons/fi";

const transition = {
  duration: 0.25,
  delay: 0.05,
  ease: [0, 0.71, 0.2, 1.01],
};

const dropdown = {
  hidden: {
    opacity: 0,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
  show: {
    opacity: 1,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
    transition: {
      delayChildren: 0.75,
      staggerChildren: 0.1,
    },
  },
};

const answer = {
  hidden: {
    opacity: 0.75,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
  show: {
    opacity: 1,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
  exit: {
    opacity: 0,
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
  },
};

const Faq = () => {
  const [faqData, setFaqData] = useState(null);
  const [clicked, setClicked] = useState(false);
  const answerRef = useRef(null);

  const handleClick = (index) => {
    if (clicked === index) {
      return setClicked(null);
    }
    setClicked(index);
  };

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "faq"] {
                question,
                answer
            }`
      )
      .then((data) => setFaqData(data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (e) => {
    if (answerRef.current && !answerRef.current.contains(e.target)) {
      setClicked(false);
    }
  };

  return (
    <div className="fag-container">
      <div className="faq">
        <div className="item-container">
          {faqData?.map((item, index) => (
            <div key={index}>
              <motion.div
                className="wrapper"
                onClick={() => handleClick(index)}
                key={index}
              >
                <h2>{item.question}</h2>
                <span>
                  {clicked === index ? <FIIcons.FiMinus /> : <FIIcons.FiPlus />}
                </span>
              </motion.div>
              {clicked === index ? (
                <motion.div
                  className="dropdown"
                  variants={dropdown}
                  initial="hidden"
                  animate="show"
                  exit="exit"
                >
                  <motion.p
                    variants={answer}
                    transition={{ ...transition }}
                    data-scroll
                    data-scroll-delay="0.13"
                    data-scroll-speed="4"
                  >
                    {item.answer}
                  </motion.p>
                </motion.div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
